import { plural } from '@cian/utils';
import { NBSP } from '../../../../../constants/symbols';
import { IRecommendedServicePackage } from '../../../../../redux/reducers';

export const getDescription = (servicePackage: IRecommendedServicePackage) => {
  const { durationInDays } = servicePackage;

  return (
    `Использовать пакет можно в${NBSP}течение ${durationInDays}` +
    `${NBSP}${plural(durationInDays, ['дня', 'дней', 'дней'])}`
  );
};
